"use strict";

var $ = require("jquery");

$(document).ready(function () {

    $("table").wrap("<div class='table-responsive'></div>");
});